// extracted by mini-css-extract-plugin
export default {"popupDropdown":"UhYt3vnGL_AHPK87Glk7","radio":"ZonY0aNbgjuLSbxen_Tv","amountTitle":"bgPjuleELKRrXgRNKtFk","switchHolder":"q0be7n5tJHtWHBeqdjGq","disabled":"VzjWzLwYkaCaYuO_Gonr"};